import { EyeShowIcon } from '@rsos/base-assets/icons';
import { EyeHideIcon } from '@rsos/base-assets/icons';
import { useDispatcherVideoContext } from '../../DispatcherVideoContext/useDispatcherVideoContext';
import { StyledButton } from './DispatcherControls.styles';

export const GoDarkButton = () => {
  const { caller, sharedCallerState, enableCallerDarkMode } =
    useDispatcherVideoContext();

  return (
    <StyledButton
      title={
        sharedCallerState.isDarkMode
          ? 'Caller must disable hidden screen'
          : 'Hide Caller Screen'
      }
      onClick={enableCallerDarkMode}
      disabled={!caller || sharedCallerState.isDarkMode}
    >
      {sharedCallerState.isDarkMode ? <EyeHideIcon /> : <EyeShowIcon />}
    </StyledButton>
  );
};
